<template>
    <ColumnaIzquierda></ColumnaIzquierda>
    <SelectorReceptores></SelectorReceptores>
</template>
<script>
import ColumnaIzquierda from '../components/ColumnaIzquierda.vue';
import SelectorReceptores from '../components/SelectorReceptores.vue';
export default {
    name: 'TargetView',
    components: {
        ColumnaIzquierda,
        SelectorReceptores,
    }
}
</script>